import { http } from '../rest';

export function initiateAdvisorAttestation(http, demo) {
  return {
    async execute() {
      try {
        if (demo) {
          return true;
        }
        await http.post('/handle_advisor_initiate_advisor_attestation');
      } catch (error) {
        if (error && error.response && error.response.status === 404) return;
        throw error;
      }
    },
  };
}

export default initiateAdvisorAttestation(http, process.env.DEMO);
